import { ComponentLocator } from '../components/component-locator';
import { inject } from '@angular/core';
import { ClassConstructor } from '@nts/std/serialization';
import { BaseAggregateComponent } from '../components/base-aggregate/base-aggregate.component';
import type { CoreOrchestratorViewModelInterface, RootViewModelInterface, WingViewModelInterface } from '@nts/std/interfaces';
import type { ToolBarComponentInterface } from '@nts/std/interfaces';

// Vedi https://github.com/ag-grid/ag-grid/issues/3415
// export function patchAgGrid() {
//     // Prevent a DOMException after editing cells with a custom cell editor.
//     Utils.clearElement = (el: HTMLElement) => {
//         el.innerHTML = '';
//     };
// }

export interface NtsAppModuleRegisterParams<
    TOrchestrator extends CoreOrchestratorViewModelInterface,
    TRootViewModel extends RootViewModelInterface
> {
    domainModelNameInPascalCase: string,
    orchestratorViewModelType: ClassConstructor<TOrchestrator>,
    rootViewModelType: ClassConstructor<TRootViewModel>,
    componentType: ClassConstructor<BaseAggregateComponent<TRootViewModel, TOrchestrator>>,
    wingViewModelType?: ClassConstructor<WingViewModelInterface>,
    wingComponentType?: ClassConstructor<any>,
    toolbarComponentType?: ClassConstructor<ToolBarComponentInterface>,
}

export abstract class NtsAppModule {

    abstract registerAll(): void;

    constructor() {
        this.registerAll();
    }

    registerAllForDomainModelType<
        TOrchestrator extends CoreOrchestratorViewModelInterface,
        TRootViewModel extends RootViewModelInterface,
    >(
        params: NtsAppModuleRegisterParams<TOrchestrator, TRootViewModel>
    ): void;
    registerAllForDomainModelType<
        TOrchestrator extends CoreOrchestratorViewModelInterface,
        TRootViewModel extends RootViewModelInterface,
    >(
        domainModelName: string,
        orchestratorViewModelType: ClassConstructor<TOrchestrator>,
        rootViewModelType: ClassConstructor<TRootViewModel>,
        componentType: ClassConstructor<BaseAggregateComponent<TRootViewModel, TOrchestrator>>,
        wingViewModelType?: ClassConstructor<WingViewModelInterface>,
        wingComponentType?: ClassConstructor<any>,
        toolbarComponentType?: ClassConstructor<ToolBarComponentInterface>,
    ): void;
    registerAllForDomainModelType<
        TOrchestrator extends CoreOrchestratorViewModelInterface,
        TRootViewModel extends RootViewModelInterface,
    >(
        domainModelNameOrOpts: string | NtsAppModuleRegisterParams<TOrchestrator, TRootViewModel>,
        orchestratorViewModelType: ClassConstructor<TOrchestrator> = undefined,
        rootViewModelType: ClassConstructor<TRootViewModel> = undefined,
        componentType: ClassConstructor<BaseAggregateComponent<TRootViewModel, TOrchestrator>> = undefined,
        wingViewModelType: ClassConstructor<WingViewModelInterface> = undefined,
        wingComponentType: ClassConstructor<any> = undefined,
        toolbarComponentType: ClassConstructor<ToolBarComponentInterface> = undefined,
    ): void {
        const componentLocator = inject(ComponentLocator);

        // Destructuring sicuro all'inizio con type narrowing
        let finalDomainModelName: string;
        let finalOrchestratorViewModelType = orchestratorViewModelType;
        let finalRootViewModelType = rootViewModelType;
        let finalComponentType = componentType;
        let finalWingViewModelType = wingViewModelType;
        let finalWingComponentType = wingComponentType;
        let finalToolbarComponentType = toolbarComponentType;

        if (typeof domainModelNameOrOpts !== 'string') {
            const opts = domainModelNameOrOpts;
            finalDomainModelName = opts.domainModelNameInPascalCase;
            finalOrchestratorViewModelType = opts.orchestratorViewModelType ?? orchestratorViewModelType;
            finalRootViewModelType = opts.rootViewModelType ?? rootViewModelType;
            finalComponentType = opts.componentType ?? componentType;
            finalWingViewModelType = opts.wingViewModelType ?? wingViewModelType;
            finalWingComponentType = opts.wingComponentType ?? wingComponentType;
            finalToolbarComponentType = opts.toolbarComponentType ?? toolbarComponentType;
        } else {
            finalDomainModelName = domainModelNameOrOpts;
        }

        componentLocator.registerAllForDomainModelType(
            finalDomainModelName,
            finalOrchestratorViewModelType,
            finalRootViewModelType,
            finalComponentType,
            finalWingViewModelType,
            finalWingComponentType,
            finalToolbarComponentType
        );
    }
}
